/**
 * https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal#implementing_an_abortable_api
 *
 * This was copied from the above link.
 * This function will return a promise given an abort signal that only rejects when the signal is aborted.
 */
export const abortPromise = (signal: AbortSignal): Promise<never> => {
  return new Promise((_resolve, reject) => {
    // If the signal is already aborted, immediately throw in order to reject the promise.
    if (signal.aborted) {
      reject(signal.reason);
      return;
    }

    // Perform the main purpose of the API
    // Call resolve(result) when done.

    // Watch for 'abort' signals
    signal.addEventListener('abort', () => {
      // Stop the main operation
      // Reject the promise with the abort reason.
      reject(signal.reason);
    });
  });
};
